import { questionTypes } from 'sharedParts';

const blockLabels = {
  [questionTypes.questionMulti]: 'Multi',
  [questionTypes.questionScale]: 'Scale',
  [questionTypes.questionSingle]: 'Single',
  [questionTypes.questionDropdown]: 'Dropdown',
  [questionTypes.longText]: 'Long',
  [questionTypes.shortText]: 'Short',
  [questionTypes.questionImageSingle]: 'Image',
  [questionTypes.questionImageMulti]: 'Image',
  [questionTypes.questionMatrixRadio]: 'Matrix',
  [questionTypes.questionMatrixScale]: 'Matrix',
  [questionTypes.questionMatrixMulti]: 'Matrix',
  [questionTypes.questionNumeric]: 'Numeric',
  [questionTypes.staticText]: 'Text',
  [questionTypes.nextButton]: 'Break',
};

export default blockLabels;
